import * as React from "react"

const SvgAlarm = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 19.714a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h1v-7q0-2.075 1.25-3.687a5.77 5.77 0 0 1 3.25-2.113v-.7q0-.624.438-1.062A1.45 1.45 0 0 1 12 2.714q.624 0 1.063.438.437.437.437 1.062v.7q2 .5 3.25 2.113T18 10.714v7h1q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm7 3q-.825 0-1.412-.587A1.93 1.93 0 0 1 10 20.714h4q0 .825-.588 1.413a1.93 1.93 0 0 1-1.412.587m-4-5h8v-7q0-1.65-1.175-2.825T12 6.714c-1.65 0-2.042.392-2.825 1.175Q8 9.064 8 10.714z" />
  </svg>
)
export default SvgAlarm
